import { render, staticRenderFns } from "./RequestTable.vue?vue&type=template&id=f32ad98e&scoped=true"
import script from "./RequestTable.vue?vue&type=script&lang=js"
export * from "./RequestTable.vue?vue&type=script&lang=js"
import style0 from "./RequestTable.vue?vue&type=style&index=0&id=f32ad98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32ad98e",
  null
  
)

export default component.exports